
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FineArtHero from './components/FineArtHero';
import ArtistStatement from './components/ArtistStatement';
import ArtworkGallery from './components/ArtworkGallery';

const FineArtPage = () => {
  useEffect(() => {
    // Update document title and meta tags
    document.title = "Fine Art Gallery - Esteban's Stache | Contemporary Art & Photography";
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Explore contemporary fine art photography and artistic works by Esteban. Award-winning pieces including portrait photography and conceptual art. View gallery and artist statement.');
    }
    
    // Update canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', '/fine-art');
    }
    
    // Add Schema.org JSON-LD for Art Gallery
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "ArtGallery",
        "name": "Fine Art Gallery - Esteban's Stache",
        "description": "Explore contemporary fine art photography and artistic works by Esteban. Award-winning pieces including portrait photography and conceptual art.",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/fine-art`,
        "artist": {
          "@type": "Person",
          "name": "Esteban",
          "jobTitle": "Fine Art Photographer & Artist",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Los Angeles",
            "addressRegion": "CA",
            "addressCountry": "US"
          }
        },
        "artMedium": "Photography",
        "artworkLocation": "Los Angeles",
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Fine Art Collection",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "VisualArtwork",
                "name": "Star is Born",
                "artMedium": "Photography",
                "dateCreated": "2019",
                "creator": {
                  "@type": "Person",
                  "name": "Esteban"
                }
              }
            }
          ]
        },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Fine Art",
              "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/fine-art`
            }
          ]
        }
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <FineArtHero />
        <ArtistStatement />
        <ArtworkGallery />
      </main>
      <Footer />
    </div>
  );
};

export default FineArtPage;
